/* eslint-disable jsx-a11y/heading-has-content */
import React, { useState, useRef, useEffect, useMemo } from "react";
import ReactDOM from "react-dom";
import { PageBase } from "../../Components/PageBase";
import { useRol } from "../../Context";
import img from "../../icons/headache_girl.jpg";
import "./Analisis.css"

const TABS = ['General', 'Comercial', 'Medios', 'Perfiles', 'Visitas', 'Power BI'];
const MONTHS = ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'];
const BASE_URL = process.env.REACT_APP_API_URL || '';
const CURRENT_YEAR = new Date().getFullYear();
const YEAR_OPTIONS = Array.from({ length: CURRENT_YEAR - 2022 }, (_, i) => 2023 + i).concat(CURRENT_YEAR);
const PIE_COLORS = ['#27877b', '#2badbb', '#CC2B61', '#e07099', '#646c9a', '#8E9DAA', '#ffb822', '#0abb87'];
const TREEMAP_COLORS = ['#2E3491', '#3D5FAA', '#2badbb', '#27877b', '#CC2B61', '#646c9a', '#ffb822', '#e07099'];
const ASESOR_COLORS = ['#4A0838', '#6F0C5A', '#921C2A', '#942F5C', '#C9022E', '#E8305A', '#FF7B7A'];

const ORIGIN_COLORS = {
    'Facebook':            '#0D4F9E',
    'Facebook Ads':        '#083A7A',
    'Google':              '#B71C1C',
    'Google Ads':          '#1A3F8F',
    'Instagram':           '#7B1256',
    'Whatsapp':            '#1B5E20',
    'Referidos':           '#BF360C',
    'Base de Datos':       '#37474F',
    'Broker':              '#4A0072',
    'Cambaceo':            '#BF360C',
    'Contacto Directo':    '#1B5E20',
    'Espectacular':        '#E65100',
    'Lonas':               '#7F1D1D',
    'Página web':          '#004D56',
    'Sitio web':           '#006064',
    'Redes sociales':      '#283593',
    'Recompra':            '#E65100',
    'Revista':             '#3E2723',
    'Señalética':          '#263238',
    'Teléfono':            '#0D3B8C',
    'Walk-in':             '#1B5E20',
    'Periódico':           '#455A64',
    'Inmobiliaria Externa':'#1A007A',
    'Inmuebles 24':        '#0D3B7A',
    'Lamudi':              '#2E5A1C',
    'Tiktok':              '#010101',
    'Radio':               '#4E342E',
    'Televisión':          '#1C2B33',
    'Volante':             '#5D3A00',
    'Propiedades.com':     '#7F0000',
    'Vivanuncios':         '#8A2500',
    'Tu Hogar México':     '#7A1038',
    'Segundamano':         '#1B5E20',
    'Metros cúbicos':      '#01579B',
    'Web':                 '#00332E',
    'Sin definir':         '#546E7A',
};

const ORIGIN_GROUPS = {
    'Facebook_Organic': 'Facebook', 'Facebook_Mobile_Feed': 'Facebook',
    'Facebook_Instant_Articles': 'Facebook', 'Facebook_Marketplace': 'Facebook',
    'Facebook_Desktop_Feed': 'Facebook Ads', 'Facebook Ads': 'Facebook Ads',
    'Google_Organic': 'Google',
    'Google_ads': 'Google Ads', 'Google Ads': 'Google Ads',
    'Instagram_Explore': 'Instagram', 'Instagram_Feed': 'Instagram', 'Instagram Ads': 'Instagram',
    'Base_Datos': 'Base de Datos', 'Base Datos': 'Base de Datos', 'Base de Datos BBR': 'Base de Datos',
    'Broker o Asesor Externo': 'Broker', 'Asesores Externos': 'Broker',
    'Periodico': 'Periódico', 'Pagina web': 'Página web',
    'Señaletica': 'Señalética', 'Telefono': 'Teléfono',
    'Sitio web Forms': 'Sitio web',
    'Redes Sociales': 'Redes sociales',
    'RECOMENDACIï¿½N': 'Referidos',
    'Espectacular South Hill (Carretera Celaya)': 'Espectacular',
};

function groupOrigins(counts) {
    const grouped = {};
    (counts || []).forEach(({ origen, total }) => {
        const key = ORIGIN_GROUPS[origen] || origen || 'Sin definir';
        grouped[key] = (grouped[key] || 0) + total;
    });
    return Object.entries(grouped)
        .map(([origen, total]) => ({ origen, total }))
        .sort((a, b) => b.total - a.total);
}

function useAnalytics(vacantCode, buttonPressed, filters) {
    const [data, setData] = useState(null);
    const { selectedAnio, fechaInicial, fechaFinal, selectedAsesores, selectedEtapas } = filters;

    useEffect(() => {
        if (!vacantCode || !buttonPressed) return;
        setData(null);
        const controller = new AbortController();

        const params = new URLSearchParams({ project_code: vacantCode });
        if (fechaInicial || fechaFinal) {
            if (fechaInicial) params.set('fecha_inicial', fechaInicial);
            if (fechaFinal) params.set('fecha_final', fechaFinal);
        } else if (selectedAnio) {
            params.set('anio', selectedAnio);
        }
        if (selectedAsesores.length > 0) params.set('recruiters', selectedAsesores.join(','));
        if (selectedEtapas.length > 0) {
            const ETAPAS_MAP = { 'Contactos': 'Contacto', 'Calificados': 'Calificado', 'Citas': 'Cita', 'Visitas': 'Visita', 'Potenciales': 'Potencial', 'Cierres': 'Cierre' };
            params.set('etapas', selectedEtapas.map(e => ETAPAS_MAP[e] ?? e).join(','));
        }

        fetch(`${BASE_URL}/api/analytics/?${params}`, {
            method: 'GET', mode: 'cors', signal: controller.signal,
        })
            .then(r => { if (!r.ok) throw new Error(`HTTP ${r.status}`); return r.json(); })
            .then(d => setData(d))
            .catch(err => { if (err.name !== 'AbortError') setData({}); });

        return () => controller.abort();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [vacantCode, buttonPressed, selectedAnio, fechaInicial, fechaFinal, selectedAsesores, selectedEtapas]);

    return data;
}

function BarChart({ monthlyCounts }) {
    const [tooltip, setTooltip] = useState(null);
    const max = Math.max(...monthlyCounts, 1);
    const chartH = 140;
    const barW = 28;
    const gap = 8;
    const paddingLeft = 36;
    const paddingBottom = 28;
    const totalW = paddingLeft + MONTHS.length * (barW + gap);

    const yTicks = 4;
    const tickValues = Array.from({ length: yTicks + 1 }, (_, i) => Math.round((max / yTicks) * i));

    return (
        <div className="analisis-barchart-wrapper">
            <svg
                viewBox={`0 0 ${totalW} ${chartH + paddingBottom}`}
                preserveAspectRatio="xMidYMid meet"
                className="analisis-barchart-svg"
            >
                {tickValues.map((val, i) => {
                    const y = chartH - (val / max) * chartH;
                    return (
                        <g key={i}>
                            <line x1={paddingLeft} x2={totalW} y1={y} y2={y} stroke="#f0f0f0" strokeWidth="1" />
                            <text x={paddingLeft - 4} y={y + 4} textAnchor="end" fontSize="8" fill="#8E9DAA">{val}</text>
                        </g>
                    );
                })}
                {monthlyCounts.map((val, i) => {
                    const barH = (val / max) * chartH;
                    const x = paddingLeft + i * (barW + gap);
                    const y = chartH - barH;
                    return (
                        <g key={i}
                            onMouseEnter={e => setTooltip({ x: e.clientX, y: e.clientY, label: MONTHS[i], val })}
                            onMouseLeave={() => setTooltip(null)}
                            style={{ cursor: 'pointer' }}
                        >
                            <rect x={x} y={y} width={barW} height={barH || 1} fill={i % 2 === 0 ? '#27877b' : '#2badbb'} rx="4" opacity="0.85" />
                            <rect x={x} y={0} width={barW} height={chartH} fill="transparent" />
                            <text x={x + barW / 2} y={chartH + paddingBottom - 6} textAnchor="middle" fontSize="8" fill="#8E9DAA">{MONTHS[i]}</text>
                        </g>
                    );
                })}
                <line x1={paddingLeft} x2={paddingLeft} y1={0} y2={chartH} stroke="#e8e8e8" strokeWidth="1" />
                <line x1={paddingLeft} x2={totalW} y1={chartH} y2={chartH} stroke="#e8e8e8" strokeWidth="1" />
            </svg>
            {tooltip && ReactDOM.createPortal(
                <div className="analisis-chart-tooltip" style={{ top: tooltip.y - 36, left: tooltip.x + 10 }}>
                    {tooltip.label}: <strong>{tooltip.val}</strong>
                </div>,
                document.body
            )}
        </div>
    );
}

function PieChart({ data, groupBy, segments: segmentsProp }) {
    const [tooltip, setTooltip] = useState(null);

    const segments = useMemo(() => {
        if (segmentsProp) return segmentsProp;
        const counts = {};
        (data || []).forEach(lead => {
            const key = lead[groupBy] || 'Sin definir';
            counts[key] = (counts[key] || 0) + 1;
        });
        return Object.entries(counts)
            .sort((a, b) => b[1] - a[1])
            .map(([label, value], i) => ({ label, value, color: PIE_COLORS[i % PIE_COLORS.length] }));
    }, [data, groupBy, segmentsProp]);

    const total = segments.reduce((s, seg) => s + seg.value, 0);
    if (total === 0) return <div className="analisis-card-empty">Sin datos</div>;

    const cx = 60, cy = 60, r = 52, innerR = 30;
    let currentAngle = -Math.PI / 2;

    const slices = segments.map(seg => {
        const angle = (seg.value / total) * 2 * Math.PI;
        const sa = currentAngle, ea = currentAngle + angle;
        currentAngle = ea;
        const x1 = cx + r * Math.cos(sa), y1 = cy + r * Math.sin(sa);
        const x2 = cx + r * Math.cos(ea), y2 = cy + r * Math.sin(ea);
        const ix1 = cx + innerR * Math.cos(ea), iy1 = cy + innerR * Math.sin(ea);
        const ix2 = cx + innerR * Math.cos(sa), iy2 = cy + innerR * Math.sin(sa);
        const large = angle > Math.PI ? 1 : 0;
        const d = `M${x1} ${y1} A${r} ${r} 0 ${large} 1 ${x2} ${y2} L${ix1} ${iy1} A${innerR} ${innerR} 0 ${large} 0 ${ix2} ${iy2}Z`;
        return { ...seg, d };
    });

    return (
        <div className="analisis-pie-wrapper">
            <svg viewBox="0 0 120 120" className="analisis-pie-svg">
                {slices.map((slice, i) => (
                    <path
                        key={i} d={slice.d} fill={slice.color} opacity="0.9"
                        onMouseEnter={e => setTooltip({ x: e.clientX, y: e.clientY, label: slice.label, val: slice.value, pct: Math.round(slice.value / total * 100) })}
                        onMouseLeave={() => setTooltip(null)}
                        style={{ cursor: 'pointer', transition: 'opacity 0.15s' }}
                        onMouseOver={e => e.currentTarget.style.opacity = 1}
                        onMouseOut={e => e.currentTarget.style.opacity = 0.9}
                    />
                ))}
                <text x={cx} y={cy - 6} textAnchor="middle" fontSize="14" fontWeight="600" fill="#212529">{total}</text>
                <text x={cx} y={cy + 10} textAnchor="middle" fontSize="7" fill="#8E9DAA">total</text>
            </svg>
            <div className="analisis-pie-legend">
                {segments.map((seg, i) => (
                    <div key={i} className="analisis-pie-legend-item">
                        <span className="analisis-pie-legend-dot" style={{ background: seg.color }} />
                        <span className="analisis-pie-legend-label">{seg.label}</span>
                        <span className="analisis-pie-legend-val">{seg.value}</span>
                    </div>
                ))}
            </div>
            {tooltip && ReactDOM.createPortal(
                <div className="analisis-chart-tooltip" style={{ top: tooltip.y - 36, left: tooltip.x + 10 }}>
                    {tooltip.label}: <strong>{tooltip.val}</strong> ({tooltip.pct}%)
                </div>,
                document.body
            )}
        </div>
    );
}


function OriginChart({ counts: countsProp }) {
    const [tooltip, setTooltip] = useState(null);

    const originData = useMemo(() => {
        const sorted = groupOrigins(countsProp).map(({ origen, total }) => [origen, total]);
        const top5 = sorted.slice(0, 5);
        const othersTotal = sorted.slice(5).reduce((sum, [, v]) => sum + v, 0);
        if (othersTotal > 0) top5.push(['Otros', othersTotal]);
        return top5;
    }, [countsProp]);

    if (originData.length === 0) return null;

    const max = Math.max(...originData.map(([, v]) => v), 1);
    const BAR_COLORS = ['#27877b', '#2badbb', '#27877b', '#2badbb', '#27877b', '#2badbb'];
    const rowH = 28;
    const gap = 10;
    const labelW = 80;
    const barAreaW = 340;
    const paddingRight = 44;
    const totalH = originData.length * (rowH + gap);
    const totalW = labelW + barAreaW + paddingRight;

    return (
        <div className="analisis-barchart-wrapper analisis-barchart-wrapper--wide" style={{ alignItems: 'center' }}>
            <svg viewBox={`0 0 ${totalW} ${totalH}`} preserveAspectRatio="xMidYMid meet" style={{ width: '100%', height: 'auto', overflow: 'visible' }}>
                {originData.map(([label, val], i) => {
                    const y = i * (rowH + gap);
                    const barW = (val / max) * barAreaW;
                    return (
                        <g key={label}
                            onMouseEnter={e => setTooltip({ x: e.clientX, y: e.clientY, label, val })}
                            onMouseLeave={() => setTooltip(null)}
                            style={{ cursor: 'default' }}
                        >
                            <text x={labelW - 8} y={y + rowH / 2 + 4} textAnchor="end" fontSize="9" fill="#667781">
                                {label.length > 14 ? label.slice(0, 13) + '…' : label}
                            </text>
                            <rect x={labelW} y={y + 4} width={barAreaW} height={rowH - 8} fill="#f5f5f5" rx="4" />
                            <rect x={labelW} y={y + 4} width={barW || 1} height={rowH - 8} fill={BAR_COLORS[i % BAR_COLORS.length]} rx="4" opacity="0.85" />
                            <text x={labelW + barW + 6} y={y + rowH / 2 + 4} fontSize="9" fill="#212529" fontWeight="600">{val}</text>
                        </g>
                    );
                })}
            </svg>
            {tooltip && ReactDOM.createPortal(
                <div className="analisis-chart-tooltip" style={{ top: tooltip.y - 36, left: tooltip.x + 10 }}>
                    {tooltip.label}: <strong>{tooltip.val}</strong>
                </div>,
                document.body
            )}
        </div>
    );
}

function OriginsBarChart({ data, counts: countsProp }) {
    const [tooltip, setTooltip] = useState(null);

    const originData = useMemo(() => {
        if (countsProp) return groupOrigins(countsProp).map(({ origen, total }) => [origen, total]);
        const counts = {};
        (data || []).forEach(lead => {
            const origin = lead.origin || 'Sin origen';
            counts[origin] = (counts[origin] || 0) + 1;
        });
        return Object.entries(counts).sort((a, b) => b[1] - a[1]);
    }, [data, countsProp]);

    if (originData.length === 0) return null;

    const max = Math.max(...originData.map(([, v]) => v), 1);
    const BAR_COLORS = ['#27877b', '#2badbb'];
    const barW = 26;
    const gap = 8;
    const paddingLeft = 32;
    const paddingBottom = 82;
    const chartH = 130;
    const totalW = paddingLeft + originData.length * (barW + gap);

    const yTicks = 4;
    const tickValues = Array.from({ length: yTicks + 1 }, (_, i) => Math.round((max / yTicks) * i));

    return (
        <div className="analisis-barchart-wrapper analisis-barchart-wrapper--wide">
            <svg viewBox={`0 0 ${totalW} ${chartH + paddingBottom}`} preserveAspectRatio="xMidYMid meet" className="analisis-barchart-svg">
                {tickValues.map((val, i) => {
                    const y = chartH - (val / max) * chartH;
                    return (
                        <g key={i}>
                            <line x1={paddingLeft} x2={totalW} y1={y} y2={y} stroke="#f0f0f0" strokeWidth="1" />
                            <text x={paddingLeft - 4} y={y + 4} textAnchor="end" fontSize="8" fill="#8E9DAA">{val}</text>
                        </g>
                    );
                })}
                {originData.map(([label, val], i) => {
                    const barH = (val / max) * chartH;
                    const x = paddingLeft + i * (barW + gap);
                    const y = chartH - barH;
                    const cx = x + barW / 2;
                    const truncated = label.length > 16 ? label.slice(0, 15) + '…' : label;
                    return (
                        <g key={label}
                            onMouseEnter={e => setTooltip({ x: e.clientX, y: e.clientY, label, val })}
                            onMouseLeave={() => setTooltip(null)}
                            style={{ cursor: 'pointer' }}
                        >
                            <rect x={x} y={y} width={barW} height={barH || 1} fill={BAR_COLORS[i % BAR_COLORS.length]} rx="4" opacity="0.85" />
                            <rect x={x} y={0} width={barW} height={chartH} fill="transparent" />
                            <text
                                x={cx} y={chartH + 6}
                                textAnchor="end"
                                fontSize="8" fill="#667781"
                                transform={`rotate(-45 ${cx} ${chartH + 6})`}
                            >
                                {truncated}
                            </text>
                        </g>
                    );
                })}
                <line x1={paddingLeft} x2={paddingLeft} y1={0} y2={chartH} stroke="#e8e8e8" strokeWidth="1" />
                <line x1={paddingLeft} x2={totalW} y1={chartH} y2={chartH} stroke="#e8e8e8" strokeWidth="1" />
            </svg>
            {tooltip && ReactDOM.createPortal(
                <div className="analisis-chart-tooltip" style={{ top: tooltip.y - 36, left: tooltip.x + 10 }}>
                    {tooltip.label}: <strong>{tooltip.val}</strong>
                </div>,
                document.body
            )}
        </div>
    );
}

function buildTreemap(items, x, y, w, h) {
    if (!items.length || w <= 0 || h <= 0) return [];
    if (items.length === 1) return [{ ...items[0], x, y, w, h }];

    const total = items.reduce((s, d) => s + d.value, 0);
    let cumSum = 0;
    let splitAt = 1;
    for (let i = 0; i < items.length - 1; i++) {
        cumSum += items[i].value;
        splitAt = i + 1;
        if (cumSum >= total / 2) break;
    }

    const a = items.slice(0, splitAt);
    const b = items.slice(splitAt);
    const aFrac = a.reduce((s, d) => s + d.value, 0) / total;

    if (w >= h) {
        const aw = aFrac * w;
        return [...buildTreemap(a, x, y, aw, h), ...buildTreemap(b, x + aw, y, w - aw, h)];
    } else {
        const ah = aFrac * h;
        return [...buildTreemap(a, x, y, w, ah), ...buildTreemap(b, x, y + ah, w, h - ah)];
    }
}

function TreemapChart({ segments }) {
    const [tooltip, setTooltip] = useState(null);
    const GAP = 2;
    const VW = 400, VH = 200;

    const rects = useMemo(() => buildTreemap(segments, 0, 0, VW, VH), [segments]);

    return (
        <div style={{ flex: 1, minHeight: 0, padding: '10px 6px 12px' }}>
            <svg viewBox={`0 0 ${VW} ${VH}`} width="100%" height="100%" style={{ display: 'block' }}>
                {rects.map((rect, i) => {
                    const rx = rect.x + GAP / 2;
                    const ry = rect.y + GAP / 2;
                    const rw = Math.max(0, rect.w - GAP);
                    const rh = Math.max(0, rect.h - GAP);
                    const fontSize = Math.min(11, rw / 7);
                    const numSize = Math.min(15, rw / 4);
                    const maxChars = Math.floor(rw / (fontSize * 0.6));
                    const label = rect.label.length > maxChars ? rect.label.slice(0, maxChars - 1) + '…' : rect.label;
                    return (
                        <g key={i}
                            onMouseEnter={e => setTooltip({ x: e.clientX, y: e.clientY, label: rect.label, val: rect.value })}
                            onMouseLeave={() => setTooltip(null)}
                            style={{ cursor: 'default' }}
                        >
                            <rect x={rx} y={ry} width={rw} height={rh} fill={rect.color} rx={3} />
                            {rw > 30 && rh > 22 && (
                                <>
                                    <text x={rx + 5} y={ry + fontSize + 3} fontSize={fontSize} fill="rgba(255,255,255,0.88)" fontWeight="600">{label}</text>
                                    <text x={rx + 5} y={ry + rh - 7} fontSize={numSize} fill="rgba(255,255,255,0.95)" fontWeight="700">{rect.value}</text>
                                </>
                            )}
                        </g>
                    );
                })}
            </svg>
            {tooltip && ReactDOM.createPortal(
                <div className="analisis-chart-tooltip" style={{ top: tooltip.y - 36, left: tooltip.x + 10 }}>
                    {tooltip.label}: <strong>{tooltip.val}</strong>
                </div>,
                document.body
            )}
        </div>
    );
}


const ETAPAS_CONTRATO = [
    { key: null, label: 'Contacto', color: '#8E9DAA' },
    { key: 'Calificado', label: 'Calificado', color: '#646c9a' },
    { key: 'Cita', label: 'Cita', color: '#2badbb' },
    { key: 'Visita', label: 'Visita', color: '#27877b' },
    { key: 'Potencial', label: 'Potencial', color: '#ffb822' },
    { key: 'Cierre', label: 'Cierre', color: '#CC2B61' },
];

function StatusBarChart({ data, counts: countsProp }) {
    const [tooltip, setTooltip] = useState(null);

    const counts = useMemo(() => {
        if (countsProp) return countsProp;
        return ETAPAS_CONTRATO.map(e => ({
            label: e.label,
            val: (data || []).filter(l => (l.contracting_status || null) === e.key).length,
            color: e.color,
        }));
    }, [data, countsProp]);

    const max = Math.max(...counts.map(c => c.val), 1);
    const chartH = 130;
    const barW = 38;
    const gap = 10;
    const paddingLeft = 8;
    const paddingBottom = 30;
    const totalW = paddingLeft + counts.length * (barW + gap);

    return (
        <div className="analisis-barchart-wrapper" style={{ maxWidth: '100%' }}>
            <svg viewBox={`0 0 ${totalW} ${chartH + paddingBottom}`} preserveAspectRatio="xMidYMid meet" className="analisis-barchart-svg">
                {counts.map(({ label, val, color }, i) => {
                    const barH = (val / max) * chartH;
                    const x = paddingLeft + i * (barW + gap);
                    const y = chartH - barH;
                    return (
                        <g key={label}
                            onMouseEnter={e => setTooltip({ x: e.clientX, y: e.clientY, label, val })}
                            onMouseLeave={() => setTooltip(null)}
                            style={{ cursor: 'pointer' }}
                        >
                            <rect x={x} y={y} width={barW} height={barH || 1} fill={color} rx="4" opacity="0.85" />
                            <rect x={x} y={0} width={barW} height={chartH} fill="transparent" />
                            <text x={x + barW / 2} y={chartH + paddingBottom - 6} textAnchor="middle" fontSize="7.5" fill="#8E9DAA">{label}</text>
                        </g>
                    );
                })}
                <line x1={paddingLeft} x2={totalW} y1={chartH} y2={chartH} stroke="#e8e8e8" strokeWidth="1" />
            </svg>
            {tooltip && ReactDOM.createPortal(
                <div className="analisis-chart-tooltip" style={{ top: tooltip.y - 36, left: tooltip.x + 10 }}>
                    {tooltip.label}: <strong>{tooltip.val}</strong>
                </div>,
                document.body
            )}
        </div>
    );
}

function PromedioIntentosCard({ data, stats }) {
    const { totalLeads, totalAttempts, avg, pctCero } = useMemo(() => {
        if (stats) return {
            totalLeads: stats.total_contactos ?? 0,
            totalAttempts: stats.total_intentos ?? 0,
            avg: stats.promedio ?? 0,
            pctCero: stats.pct_sin_contacto ?? 0,
        };
        const totalLeads = (data || []).length;
        const totalAttempts = (data || []).reduce((s, l) => s + (l.contact_attempts || 0), 0);
        const avg = totalLeads ? totalAttempts / totalLeads : 0;
        const cero = (data || []).filter(l => (l.contact_attempts || 0) === 0).length;
        return { totalLeads, totalAttempts, avg, pctCero: totalLeads ? Math.round(cero / totalLeads * 100) : 0 };
    }, [data, stats]);

    if (!totalLeads) return <div className="analisis-card-empty">Sin datos</div>;

    const MAX_REF = 10;
    const pct = Math.min(avg / MAX_REF, 1);
    const cx = 70, cy = 70, r = 52;
    const startAngle = Math.PI * 0.75;
    const sweepAngle = Math.PI * 1.5;
    const endAngle = startAngle + sweepAngle * pct;
    const toXY = (a, radius) => ({ x: cx + radius * Math.cos(a), y: cy + radius * Math.sin(a) });
    const trackStart = toXY(startAngle, r), trackEnd = toXY(startAngle + sweepAngle, r);
    const fillEnd = toXY(endAngle, r);
    const large = sweepAngle * pct > Math.PI ? 1 : 0;
    const trackD = `M${trackStart.x} ${trackStart.y} A${r} ${r} 0 1 1 ${trackEnd.x} ${trackEnd.y}`;
    const fillD = pct > 0
        ? `M${trackStart.x} ${trackStart.y} A${r} ${r} 0 ${large} 1 ${fillEnd.x} ${fillEnd.y}`
        : '';

    return (
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', flex: 1, gap: 4, padding: '12px 8px' }}>
            <svg viewBox="0 0 140 105" width="160" style={{ overflow: 'visible' }}>
                <path d={trackD} fill="none" stroke="#f0f0f0" strokeWidth="10" strokeLinecap="round" />
                {fillD && <path d={fillD} fill="none" stroke="#27877b" strokeWidth="10" strokeLinecap="round" />}
                <text x={cx} y={cy - 4} textAnchor="middle" fontSize="22" fontWeight="700" fill="#1a2332">{avg.toFixed(1)}</text>
                <text x={cx} y={cy + 14} textAnchor="middle" fontSize="8" fill="#8E9DAA">intentos / contacto</text>
            </svg>
            <div style={{ display: 'flex', gap: 20, fontSize: 11, color: '#667781' }}>
                <div style={{ textAlign: 'center' }}>
                    <div style={{ fontWeight: 700, fontSize: 15, color: '#1a2332' }}>{totalAttempts}</div>
                    <div>intentos totales</div>
                </div>
                <div style={{ textAlign: 'center' }}>
                    <div style={{ fontWeight: 700, fontSize: 15, color: '#1a2332' }}>{totalLeads}</div>
                    <div>contactos</div>
                </div>
                <div style={{ textAlign: 'center' }}>
                    <div style={{ fontWeight: 700, fontSize: 15, color: pctCero > 40 ? '#CC2B61' : '#1a2332' }}>{pctCero}%</div>
                    <div>sin contacto</div>
                </div>
            </div>
        </div>
    );
}

function ComercialTab({ analyticsData }) {
    if (!analyticsData) return (
        <div className="analisis-content-grid">
            {[...Array(4)].map((_, i) => (
                <div key={i} className="analisis-card analisis-card--skeleton">
                    <div className="analisis-skeleton-header">
                        <div className="analisis-skeleton-line analisis-skeleton-line--title" />
                        <div className="analisis-skeleton-line analisis-skeleton-line--badge" />
                    </div>
                    <div className="analisis-skeleton-chart">
                        {[...Array(6)].map((_, j) => (
                            <div key={j} className="analisis-skeleton-bar" style={{ height: `${20 + Math.random() * 60}%` }} />
                        ))}
                    </div>
                </div>
            ))}
        </div>
    );

    const comercial = analyticsData.comercial || {};
    const asesorSegments = (comercial.comparativa_asesores || []).map((item, i) => ({
        label: item.nombre, value: item.total, color: ASESOR_COLORS[i % ASESOR_COLORS.length],
    }));
    const intentosSegments = (comercial.intentos_por_asesor || []).map((item, i) => ({
        label: item.nombre, value: item.total_intentos, color: TREEMAP_COLORS[i % TREEMAP_COLORS.length],
    }));
    const estatusSegments = (comercial.estatus || []).map((item, i) => ({
        label: item.tag, value: item.total, color: PIE_COLORS[i % PIE_COLORS.length],
    }));
    const etapaCounts = ETAPAS_CONTRATO.map(e => {
        const found = (comercial.volumen_por_etapa || []).find(item => item.etapa === e.label);
        return { label: e.label, val: found?.total || 0, color: e.color };
    });

    return (
        <div className="analisis-content-grid">
            <div className="analisis-card">
                <div className="analisis-card-header">
                    <span className="analisis-card-title">Comparativa de asesores</span>
                </div>
                {asesorSegments.length > 0
                    ? <TreemapChart segments={asesorSegments} />
                    : <div className="analisis-card-empty">Sin datos para el periodo seleccionado</div>
                }
            </div>
            <div className="analisis-cards-column">
                <div className="analisis-card">
                    <div className="analisis-card-header">
                        <span className="analisis-card-title">Promedio de intentos</span>
                    </div>
                    <PromedioIntentosCard stats={comercial.promedio_intentos} />
                </div>
                <div className="analisis-card">
                    <div className="analisis-card-header">
                        <span className="analisis-card-title">Estatus</span>
                    </div>
                    {estatusSegments.length > 0
                        ? <PieChart segments={estatusSegments} />
                        : <div className="analisis-card-empty">Sin datos</div>
                    }
                </div>
            </div>
            <div className="analisis-card">
                <div className="analisis-card-header">
                    <span className="analisis-card-title">Intentos de contacto por asesor</span>
                </div>
                {intentosSegments.length > 0
                    ? <TreemapChart segments={intentosSegments} />
                    : <div className="analisis-card-empty">Sin datos</div>
                }
            </div>
            <div className="analisis-card">
                <div className="analisis-card-header">
                    <span className="analisis-card-title">Contactos por etapa</span>
                </div>
                {etapaCounts.some(c => c.val > 0)
                    ? <StatusBarChart counts={etapaCounts} />
                    : <div className="analisis-card-empty">Sin datos para el periodo seleccionado</div>
                }
            </div>
        </div>
    );
}

function GeneralTab({ analyticsData }) {
    if (!analyticsData) return (
        <div className="analisis-content-grid">
            {[...Array(4)].map((_, i) => (
                <div key={i} className="analisis-card analisis-card--skeleton">
                    <div className="analisis-skeleton-header">
                        <div className="analisis-skeleton-line analisis-skeleton-line--title" />
                        <div className="analisis-skeleton-line analisis-skeleton-line--badge" />
                    </div>
                    <div className="analisis-skeleton-chart">
                        {[...Array(12)].map((_, j) => (
                            <div key={j} className="analisis-skeleton-bar" style={{ height: `${20 + Math.random() * 60}%` }} />
                        ))}
                    </div>
                </div>
            ))}
        </div>
    );

    const general = analyticsData.general || {};
    const medios = analyticsData.medios || {};
    const monthlyCounts = general.contactos_por_mes ?? medios.contactos_por_mes ?? Array(12).fill(0);
    const hasMonthly = Array.isArray(monthlyCounts) && monthlyCounts.some(v => v > 0);

    const descartadoSegments = (general.motivos_descarte || []).map((d, i) => ({
        label: d.motivo, value: d.total, color: PIE_COLORS[i % PIE_COLORS.length],
    }));
    const estatusSegments = (general.estatus || []).map((d, i) => ({
        label: d.tag, value: d.total, color: PIE_COLORS[i % PIE_COLORS.length],
    }));
    const asesorSegments = (general.comparativa_asesores || []).map((d, i) => ({
        label: d.nombre, value: d.total, color: ASESOR_COLORS[i % ASESOR_COLORS.length],
    }));
    const originCounts = general.contactos_por_origen ?? medios.contactos_por_origen ?? [];
    const originSegments = groupOrigins(originCounts).map((d, i) => ({
        label: d.origen, value: d.total, color: TREEMAP_COLORS[i % TREEMAP_COLORS.length],
    }));

    return (
        <div className="analisis-content-grid">
            <div className="analisis-card">
                <div className="analisis-card-header">
                    <span className="analisis-card-title">Contactos por mes</span>
                </div>
                {hasMonthly
                    ? <BarChart monthlyCounts={monthlyCounts} />
                    : <div className="analisis-card-empty">Sin datos para el periodo seleccionado</div>
                }
            </div>
            <div className="analisis-cards-column">
                <div className="analisis-card">
                    <div className="analisis-card-header">
                        <span className="analisis-card-title">Motivos de descarte</span>
                    </div>
                    {descartadoSegments.length > 0
                        ? <PieChart segments={descartadoSegments} />
                        : <div className="analisis-card-empty">Sin datos</div>
                    }
                </div>
                <div className="analisis-card">
                    <div className="analisis-card-header">
                        <span className="analisis-card-title">Estatus</span>
                    </div>
                    {estatusSegments.length > 0
                        ? <PieChart segments={estatusSegments} />
                        : <div className="analisis-card-empty">Sin datos</div>
                    }
                </div>
            </div>
            <div className="analisis-card">
                <div className="analisis-card-header">
                    <span className="analisis-card-title">Contactos por origen o medio</span>
                </div>
                {originSegments.length > 0
                    ? <TreemapChart segments={originSegments} />
                    : <div className="analisis-card-empty">Sin datos para el periodo seleccionado</div>
                }
            </div>
            <div className="analisis-card">
                <div className="analisis-card-header">
                    <span className="analisis-card-title">Comparativa de asesores</span>
                </div>
                {asesorSegments.length > 0
                    ? <TreemapChart segments={asesorSegments} />
                    : <div className="analisis-card-empty">Sin datos para el periodo seleccionado</div>
                }
            </div>
        </div>
    );
}

const ETAPA_OPTIONS = [
    { value: 'Contactos', label: 'Contactos' },
    { value: 'Calificados', label: 'Calificados' },
    { value: 'Citas', label: 'Citas' },
    { value: 'Visitas', label: 'Visitas' },
    { value: 'Potenciales', label: 'Potenciales' },
    { value: 'Cierres', label: 'Cierres' },
];

function MultiSelectFilter({ placeholder, options, selected, onChange }) {
    const [open, setOpen] = useState(false);
    const [dropdownStyle, setDropdownStyle] = useState({});
    const triggerRef = useRef(null);
    const dropdownRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (
                triggerRef.current && !triggerRef.current.contains(e.target) &&
                dropdownRef.current && !dropdownRef.current.contains(e.target)
            ) setOpen(false);
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const handleOpen = () => {
        if (!open && triggerRef.current) {
            const rect = triggerRef.current.getBoundingClientRect();
            setDropdownStyle({ position: 'fixed', top: rect.bottom + 6, left: rect.left, minWidth: rect.width });
        }
        setOpen(o => !o);
    };

    const toggle = (value) => {
        onChange(selected.includes(value) ? selected.filter(s => s !== value) : [...selected, value]);
    };

    const label = selected.length === 0
        ? placeholder
        : selected.length === 1
            ? options.find(o => o.value === selected[0])?.label || placeholder
            : `${selected.length} seleccionados`;

    return (
        <div className="analisis-multiselect" ref={triggerRef}>
            <button className="equipo-periodo-select analisis-multiselect-trigger" onClick={handleOpen} type="button">
                {label}
            </button>
            {open && ReactDOM.createPortal(
                <div className="analisis-multiselect-dropdown" ref={dropdownRef} style={dropdownStyle}>
                    {options.map(opt => (
                        <label key={opt.value} className="analisis-multiselect-option">
                            <input type="checkbox" checked={selected.includes(opt.value)} onChange={() => toggle(opt.value)} />
                            {opt.label}
                        </label>
                    ))}
                </div>,
                document.body
            )}
        </div>
    );
}

const PERFILES_CARDS = [
    { title: 'Edad',              field: 'age',             apiKey: 'edad',           type: 'waffle' },
    { title: 'Presupuesto',       field: 'budget',          apiKey: 'presupuesto',    type: 'waffle' },
    { title: 'Razón de compra',   field: 'purchase_reason', apiKey: 'razon_compra',   type: 'waffle' },
    { title: 'Tiempo de compra',  field: 'purchase_time',   apiKey: 'tiempo_compra',  type: 'waffle' },
    { title: 'Género',            field: 'gender',          apiKey: 'genero',         type: 'pie' },
    { title: 'Etapa de vida',     field: 'life_status',     apiKey: 'etapa_vida',     type: 'pie' },
    { title: 'Estado civil',      field: 'marital_status',  apiKey: 'estado_civil',   type: 'pie' },
    { title: 'Medio de contacto', field: 'contact_type',    apiKey: 'medio_contacto', type: 'pie' },
];

function WaffleChart({ data, field, counts: countsProp }) {
    const [tooltip, setTooltip] = useState(null);

    const segments = useMemo(() => {
        let entries;
        if (countsProp) {
            entries = countsProp.map(({ valor, total }) => [valor, total]);
        } else {
            const counts = {};
            (data || []).forEach(lead => {
                const key = lead[field] || 'Sin definir';
                counts[key] = (counts[key] || 0) + 1;
            });
            entries = Object.entries(counts).sort((a, b) => b[1] - a[1]);
        }
        const total = entries.reduce((s, [, v]) => s + v, 0);
        if (total === 0) return [];
        const sorted = entries
            .map(([label, value], i) => ({ label, value, exact: (value / total) * 100, color: PIE_COLORS[i % PIE_COLORS.length] }));
        const floors = sorted.map(s => ({ ...s, squares: Math.floor(s.exact), rem: s.exact - Math.floor(s.exact) }));
        const spare = 100 - floors.reduce((s, f) => s + f.squares, 0);
        floors.sort((a, b) => b.rem - a.rem).forEach((f, i) => { if (i < spare) f.squares += 1; });
        return floors.sort((a, b) => b.value - a.value);
    }, [data, field, countsProp]);

    if (segments.length === 0) return null;

    const grid = segments.flatMap(seg => Array(seg.squares).fill(seg));
    const COLS = 10, SIZE = 13, GAP = 2;
    const totalW = COLS * (SIZE + GAP);
    const totalH = Math.ceil(grid.length / COLS) * (SIZE + GAP);

    return (
        <div style={{ flex: 1, minHeight: 0, display: 'flex', flexDirection: 'column', padding: '8px 12px 6px', gap: 8, overflow: 'hidden' }}>
            <svg viewBox={`0 0 ${totalW} ${totalH}`} style={{ width: '100%', maxHeight: 160, flexShrink: 0 }}>
                {grid.map((seg, i) => {
                    const col = i % COLS;
                    const row = Math.floor(i / COLS);
                    return (
                        <rect key={i}
                            x={col * (SIZE + GAP)} y={row * (SIZE + GAP)}
                            width={SIZE} height={SIZE} rx={2}
                            fill={seg.color} opacity={0.88}
                            onMouseEnter={e => setTooltip({ x: e.clientX, y: e.clientY, label: seg.label, val: seg.value, pct: seg.squares })}
                            onMouseLeave={() => setTooltip(null)}
                            style={{ cursor: 'pointer' }}
                        />
                    );
                })}
            </svg>
            <div className="analisis-pie-legend" style={{ overflowY: 'auto', scrollbarWidth: 'none' }}>
                {segments.map((seg, i) => (
                    <div key={i} className="analisis-pie-legend-item">
                        <span className="analisis-pie-legend-dot" style={{ background: seg.color }} />
                        <span className="analisis-pie-legend-label">{seg.label}</span>
                        <span className="analisis-pie-legend-val">{seg.squares}%</span>
                    </div>
                ))}
            </div>
            {tooltip && ReactDOM.createPortal(
                <div className="analisis-chart-tooltip" style={{ top: tooltip.y - 36, left: tooltip.x + 10 }}>
                    {tooltip.label}: <strong>{tooltip.pct}%</strong> ({tooltip.val})
                </div>,
                document.body
            )}
        </div>
    );
}

function PerfilesTab({ analyticsData }) {
    if (!analyticsData) return (
        <div className="analisis-content-grid analisis-content-grid--perfiles">
            {PERFILES_CARDS.map(({ field }) => (
                <div key={field} className="analisis-card analisis-card--skeleton">
                    <div className="analisis-skeleton-header">
                        <div className="analisis-skeleton-line analisis-skeleton-line--title" />
                    </div>
                    <div className="analisis-skeleton-chart">
                        {[...Array(4)].map((_, j) => (
                            <div key={j} className="analisis-skeleton-bar" style={{ height: `${25 + Math.random() * 50}%` }} />
                        ))}
                    </div>
                </div>
            ))}
        </div>
    );

    const perfiles = analyticsData.perfiles || {};

    return (
        <div className="analisis-content-grid analisis-content-grid--perfiles">
            {PERFILES_CARDS.map(({ title, field, apiKey, type }) => {
                const counts = perfiles[apiKey] || [];
                const segments = counts.map((d, i) => ({ label: d.valor, value: d.total, color: PIE_COLORS[i % PIE_COLORS.length] }));
                return (
                    <div key={field} className="analisis-card">
                        <div className="analisis-card-header">
                            <span className="analisis-card-title">{title}</span>
                        </div>
                        {counts.length > 0
                            ? type === 'waffle'
                                ? <WaffleChart counts={counts} />
                                : <PieChart segments={segments} />
                            : <div className="analisis-card-empty">Sin datos</div>
                        }
                    </div>
                );
            })}
        </div>
    );
}

function MediosTab({ analyticsData }) {
    const skeletonCard = (
        <div className="analisis-card analisis-card--skeleton">
            <div className="analisis-skeleton-header">
                <div className="analisis-skeleton-line analisis-skeleton-line--title" />
                <div className="analisis-skeleton-line analisis-skeleton-line--badge" />
            </div>
            <div className="analisis-skeleton-chart">
                {[...Array(6)].map((_, j) => (
                    <div key={j} className="analisis-skeleton-bar" style={{ height: `${20 + Math.random() * 60}%` }} />
                ))}
            </div>
        </div>
    );

    const mediosGrid = (children) => (
        <div style={{ flex: 1, minHeight: 0, display: 'grid', gridTemplateColumns: '7fr 5fr', gap: '15px' }}>
            {children}
        </div>
    );

    if (!analyticsData) return mediosGrid(
        <>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '15px', minHeight: 0 }}>
                {skeletonCard}
                {skeletonCard}
            </div>
            {skeletonCard}
        </>
    );

    const medios = analyticsData.medios || {};
    const originCounts = medios.contactos_por_origen || [];
    const monthlyCounts = medios.contactos_por_mes ?? Array(12).fill(0);
    const hasMonthly = monthlyCounts.some(v => v > 0);
    const descartadoSegments = (medios.motivos_descarte || []).map((d, i) => ({
        label: d.motivo, value: d.total, color: PIE_COLORS[i % PIE_COLORS.length],
    }));
    const originSegments = groupOrigins(originCounts).map((d, i) => ({
        label: d.origen, value: d.total, color: TREEMAP_COLORS[i % TREEMAP_COLORS.length],
    }));
    const totalContactos = originCounts.reduce((s, d) => s + d.total, 0);

    return mediosGrid(
        <>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '15px', minHeight: 0 }}>
                <div className="analisis-card" style={{ flex: 1, minHeight: 0 }}>
                    <div className="analisis-card-header">
                        <span className="analisis-card-title">Contactos por origen o medio</span>
                        <span className="analisis-card-total">{totalContactos} contactos</span>
                    </div>
                    {originSegments.length > 0
                        ? <TreemapChart segments={originSegments} />
                        : <div className="analisis-card-empty">Sin datos para el periodo seleccionado</div>
                    }
                </div>
                <div className="analisis-card" style={{ flex: 1, minHeight: 0 }}>
                    <div className="analisis-card-header">
                        <span className="analisis-card-title">Contactos por mes</span>
                    </div>
                    {hasMonthly
                        ? <BarChart monthlyCounts={monthlyCounts} />
                        : <div className="analisis-card-empty">Sin datos para el periodo seleccionado</div>
                    }
                </div>
            </div>
            <div className="analisis-card">
                <div className="analisis-card-header">
                    <span className="analisis-card-title">Motivos de descarte</span>
                </div>
                {descartadoSegments.length > 0
                    ? <div className="analisis-pie--large"><PieChart segments={descartadoSegments} /></div>
                    : <div className="analisis-card-empty">Sin datos</div>
                }
            </div>
        </>
    );
}

function VisitasTab({ analyticsData }) {
    const skeletonCard = (
        <div className="analisis-card analisis-card--skeleton">
            <div className="analisis-skeleton-header">
                <div className="analisis-skeleton-line analisis-skeleton-line--title" />
                <div className="analisis-skeleton-line analisis-skeleton-line--badge" />
            </div>
            <div className="analisis-skeleton-chart">
                {[...Array(6)].map((_, j) => (
                    <div key={j} className="analisis-skeleton-bar" style={{ height: `${20 + Math.random() * 60}%` }} />
                ))}
            </div>
        </div>
    );

    if (!analyticsData) return (
        <div className="analisis-content-grid">
            {skeletonCard}{skeletonCard}{skeletonCard}{skeletonCard}
        </div>
    );

    const medios = analyticsData.medios || {};
    const originCounts = medios.contactos_por_origen || [];
    const monthlyCounts = medios.contactos_por_mes ?? Array(12).fill(0);
    const hasMonthly = monthlyCounts.some(v => v > 0);
    const descartadoSegments = (medios.motivos_descarte || []).map((d, i) => ({
        label: d.motivo, value: d.total, color: PIE_COLORS[i % PIE_COLORS.length],
    }));
    const originSegments = groupOrigins(originCounts).map((d, i) => ({
        label: d.origen, value: d.total, color: TREEMAP_COLORS[i % TREEMAP_COLORS.length],
    }));

    return (
        <div className="analisis-content-grid">
            <div className="analisis-card">
                <div className="analisis-card-header">
                    <span className="analisis-card-title">Contactos por origen o medio</span>
                </div>
                {originSegments.length > 0
                    ? <TreemapChart segments={originSegments} />
                    : <div className="analisis-card-empty">Sin datos para el periodo seleccionado</div>
                }
            </div>
            <div className="analisis-card" />
            <div className="analisis-card">
                <div className="analisis-card-header">
                    <span className="analisis-card-title">Motivos de descarte</span>
                </div>
                {descartadoSegments.length > 0
                    ? <PieChart segments={descartadoSegments} />
                    : <div className="analisis-card-empty">Sin datos</div>
                }
            </div>
            <div className="analisis-card">
                <div className="analisis-card-header">
                    <span className="analisis-card-title">Contactos por mes</span>
                </div>
                {hasMonthly
                    ? <BarChart monthlyCounts={monthlyCounts} />
                    : <div className="analisis-card-empty">Sin datos para el periodo seleccionado</div>
                }
            </div>
        </div>
    );
}

function Analisis() {
    const { report_BI, listaUsers, vacantCode, buttonPressed } = useRol();
    const [activeTab, setActiveTab] = useState('General');
    const [selectedAsesores, setSelectedAsesores] = useState([]);
    const [selectedEtapas, setSelectedEtapas] = useState([]);
    const [fechaInicial, setFechaInicial] = useState('');
    const [fechaFinal, setFechaFinal] = useState('');
    const [selectedAnio, setSelectedAnio] = useState(String(new Date().getFullYear()));

    const filters = { selectedAsesores, selectedEtapas, fechaInicial, fechaFinal, selectedAnio };
    const analyticsData = useAnalytics(vacantCode, buttonPressed, filters);

    const contactCount = useMemo(
        () => (analyticsData?.general?.contactos_por_mes ?? []).reduce((s, v) => s + v, 0),
        [analyticsData]
    );
    const discardCount = analyticsData?.general?.total_descartados ?? 0;

    return (
        <>
            <PageBase />
            <div className="main-content">
                <div className="analisis-container">
                    <div className="analisis-tabs-wrapper">
                        <div className="analisis-tabs-row">
                            {TABS.map(tab => (
                                <button
                                    key={tab}
                                    className={`analisis-tab-item${activeTab === tab ? ' analisis-tab-item--active' : ''}`}
                                    onClick={() => setActiveTab(tab)}
                                >
                                    {tab}
                                </button>
                            ))}
                        </div>
                        <div className="analisis-filtros-container">
                            <div className="analisis-filtro">
                                <MultiSelectFilter
                                    placeholder="Asesores"
                                    options={listaUsers?.map(u => ({ value: u.id, label: `${u.first_name || ''} ${u.last_name || ''}`.trim() })) || []}
                                    selected={selectedAsesores}
                                    onChange={setSelectedAsesores}
                                />
                            </div>
                            <div className="analisis-filtro">
                                <MultiSelectFilter
                                    placeholder="Etapa"
                                    options={ETAPA_OPTIONS}
                                    selected={selectedEtapas}
                                    onChange={setSelectedEtapas}
                                />
                            </div>
                            <div className="analisis-filtro">
                                <input
                                    type={fechaInicial ? 'date' : 'text'}
                                    placeholder="Fecha inicial"
                                    className="equipo-periodo-select analisis-date-input"
                                    value={fechaInicial}
                                    onFocus={e => { e.target.type = 'date'; }}
                                    onBlur={e => { if (!e.target.value) e.target.type = 'text'; }}
                                    onChange={e => setFechaInicial(e.target.value)}
                                />
                            </div>
                            <div className="analisis-filtro">
                                <input
                                    type={fechaFinal ? 'date' : 'text'}
                                    placeholder="Fecha final"
                                    className="equipo-periodo-select analisis-date-input"
                                    value={fechaFinal}
                                    onFocus={e => { e.target.type = 'date'; }}
                                    onBlur={e => { if (!e.target.value) e.target.type = 'text'; }}
                                    onChange={e => setFechaFinal(e.target.value)}
                                />
                            </div>
                            <div className="analisis-filtro">
                                <select className="equipo-periodo-select" value={selectedAnio} onChange={e => setSelectedAnio(e.target.value)}>
                                    <option value="">Todos los años</option>
                                    {[...new Set(YEAR_OPTIONS)].map(y => (
                                        <option key={y} value={String(y)}>{y}</option>
                                    ))}
                                </select>
                            </div>
                            <div className="analisis-filtro">
                                <button className="analisis-btn"><span className="analisis-btn-count">{contactCount}</span> Contactos</button>
                            </div>
                            <div className="analisis-filtro">
                                <button className="analisis-btn"><span className="analisis-btn-count">{discardCount}</span> Descartados</button>
                            </div>
                        </div>
                    </div>

                    {activeTab === 'General' && <GeneralTab analyticsData={analyticsData} />}
                    {activeTab === 'Comercial' && <ComercialTab analyticsData={analyticsData} />}
                    {activeTab === 'Perfiles' && <PerfilesTab analyticsData={analyticsData} />}
                    {activeTab === 'Medios' && <MediosTab analyticsData={analyticsData} />}
                    {activeTab === 'Visitas' && <VisitasTab analyticsData={analyticsData} />}
                    {activeTab === 'Power BI' && (
                        report_BI ? (
                            <iframe src={report_BI} title="Contenido externo" width="100%" height="100%" />
                        ) : (
                            <div className="analisis-porlet-card">
                                <img src={img} alt="headache_girl" />
                                <h2>Aún no hay reportes creados</h2>
                                <h5>Contacta al equipo de soporte para comenzar a visualizarlo.</h5>
                            </div>
                        )
                    )}
                </div>
            </div>
            <div className="analisis-movil">
                <div className="container-main-movil">
                    <div className="card-analisis-movil">
                        <img src={img} alt="" />
                        <div className="card-text-analisis-movil">
                            <label>Aún no hay reportes creados</label>
                            <span>Contacta al equipo de soporte para comenzar a visualizarlo.</span>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export { Analisis }
